import { render, staticRenderFns } from "./mainFoot.vue?vue&type=template&id=3988cd15&scoped=true&"
import script from "./mainFoot.vue?vue&type=script&lang=js&"
export * from "./mainFoot.vue?vue&type=script&lang=js&"
import style0 from "./mainFoot.vue?vue&type=style&index=0&id=3988cd15&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3988cd15",
  null
  
)

export default component.exports